import axios from 'axios';
import * as CookieService from '../Cookie/CookieService';

export function getStudentList(className, userName, pageVO) {
    let setParam = '/api/v1/user/studentpaging?';
    if(className != null) {
	setParam += '&className=' + className;
    } 
    if(userName != null) {
	setParam += '&userName=' + userName;
    }
    if (pageVO != null) {
        setParam += '&page=' + pageVO.page + '&size=' + pageVO.size + '&sort=' + pageVO.sortBy + ',' + pageVO.direction;
    }console.log(setParam);
    return axios.get(setParam, CookieService.setHeaders());
}



// WEBPACK FOOTER //
// ./src/services/Teacher/AdminStudentService.js